import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ChatListMessages from '../../Chat/ChatListMessages';
import { deleteChatList } from '../../../redux/actions/chat/deleteChatList';
import { useDispatch, useSelector } from 'react-redux';
import { resetDeleteChatList } from '../../../redux/slices/chat.slice';
import clsx from 'clsx';
import VacancyCellManager from '../Vacancy/VacancyCellManager';
// import { Link } from 'react-router-dom'

function MessagesList({ currentItems, check, currentState, isSelf, form }) {
  let navigate = useNavigate();
  const userChecked = form.watch('userChecked');
  const dispatch = useDispatch();

  const handleDelete = () => {
    Swal.fire({
      title: 'Вы действительно хотите удалить сообщения?',
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Да',
      cancelButtonText: 'Нет',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteChatList({
            chats: Object.keys(userChecked)
              ?.filter((key) => userChecked[key])
              .map((key) => key),
          }),
        );
      }
    });
  };
  const {
    getMe: { data: getMeData, error: getMeError, loading: getMeLoading },
  } = useSelector((state) => state.user);
  return (
    <div className="flex flex-col gap-3">
      {userChecked && Object.keys(userChecked)?.length ? (
        <button
          type="button"
          className={clsx('self-end text-center border rounded py-2 px-4  text-red-400 border-red-400 border-1 w-full md:w-fit hover:text-white bg-white hover:bg-red-500 transition ease-in-out duration-300')}
          onClick={handleDelete}
          //  isSelf && 'mt-3 mr-6'
        >
          Удалить
        </button>
      ) : (
        ''
      )}
      <div className="overflow-x-auto">
        <div className="min-w-full inline-block align-middle">
          <div className="overflow-hidden">
            {/* {isSelf ? (
              <div className="chatlist w-full flex flex-col items-center">
                <div className="h-96 overflow-y-scroll w-full " style={{ maxHeight: 'calc(100vh - 288px)' }}>
                  <ul className="flex flex-col zero:w-full p-2">
                    {currentItems &&
                      currentItems.map((item) => (
                        <ChatListMessages
                          {...item}
                          key={item.id}
                          checkbox={
                            <td className="pr-2 py-3 whitespace-nowrap text-sm text-gray-800" onClick={(e) => e.stopPropagation()}>
                              <input
                                name={item.num}
                                type="checkbox"
                                aria-checked={'false'}
                                onClick={() => {}}
                                className="select_checkbox h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                                defaultChecked={userChecked[item.id]}
                                checked={!!userChecked[item.id]}
                                onChange={(e) => {
                                  let updateChecked;
                                  if (e.target.checked) {
                                    updateChecked = { ...userChecked, [item.id]: true };
                                    form.setValue('userChecked', updateChecked);
                                  } else {
                                    delete userChecked[item.id];
                                    updateChecked = userChecked;
                                    form.setValue('userChecked', userChecked);
                                  }
                                }}
                              />
                            </td>
                          }
                        />
                      ))}
                  </ul>
                </div>
              </div>
            ) : ( */}
            <table className="min-w-full divide-y divide-gray-200">
              <tbody className="divide-y divide-gray-200 items-center justify-center align-middle">
                {currentItems &&
                  currentItems.map((item) => {
                    const firstSide = isSelf ? item?.sides?.find((side) => side?.user?.id != getMeData?.id) : item.sides[0];
                    const secondSide = isSelf ? firstSide : item.sides[1];
                    return (
                      <tr
                        key={item.id}
                        className={clsx('cursor-pointer transition duration-300 ease-in-out hover:bg-gray-100', item?.unread_messages && item?.type !== 'employer_candidate' && item?.type !== 'staff_staff' && 'font-bold')}
                        onClick={(e) => {
                          navigate(`/chat/${item?.id}`);
                        }}>
                        {check ? (
                          <td className="pr-2 py-3 whitespace-nowrap text-sm text-gray-800" onClick={(e) => e.stopPropagation()}>
                            <input
                              name={item.num}
                              type="checkbox"
                              aria-checked={'false'}
                              onClick={() => {}}
                              className="select_checkbox h-4 w-4 rounded border-gray-300 text-blue-500 focus:ring-blue-500"
                              defaultChecked={userChecked[item.id]}
                              checked={!!userChecked[item.id]}
                              onChange={(e) => {
                                let updateChecked;
                                if (e.target.checked) {
                                  updateChecked = { ...userChecked, [item.id]: true };
                                  form.setValue('userChecked', updateChecked);
                                } else {
                                  delete userChecked[item.id];
                                  updateChecked = userChecked;
                                  form.setValue('userChecked', userChecked);
                                }
                              }}
                            />
                          </td>
                        ) : (
                          ''
                        )}
                        {item?.type == 'support' ? (
                          <>
                            <td className={clsx('pz-2 py-3 whitespace-nowrap text-sm text-gray-800 flex flex-col items-start justify-start', item?.unread_messages && 'font-bold')}>
                              <p className="flex items-center gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" className="-mt-[2px]">
                                  <path fill="rgba(0,0,0,0.6)" d="M12 1c-5 0-9 4-9 9v7a3 3 0 0 0 3 3h3v-8H5v-2a7 7 0 0 1 7-7a7 7 0 0 1 7 7v2h-4v8h4v1h-7v2h6a3 3 0 0 0 3-3V10c0-5-4.03-9-9-9" />
                                </svg>
                                Тех.поддержка
                              </p>
                              <p className="text-gray-400">
                                {firstSide?.user?.id ?? firstSide?.employer?.id} - {`${firstSide?.user?.full_name ?? firstSide?.employer?.name}`}
                              </p>
                              <p className="text-gray-400" style={{ fontSize: '12px' }}>
                                ИНН {firstSide?.user?.inn ?? firstSide?.employer?.inn}
                              </p>
                            </td>
                          </>
                        ) : item?.vacancy ? (
                          <>
                            {' '}
                            <td className={clsx('pz-2 py-3 whitespace-nowrap text-sm text-gray-800 flex flex-col items-start justify-start', item?.unread_messages && 'font-bold')}>
                              <p>Вакансия «{item.vacancy?.name}»</p>
                              <p className="text-gray-400">
                                {item.vacancy?.employer?.id} - {item.vacancy?.employer?.name}
                              </p>{' '}
                              <p className="text-gray-400" style={{ fontSize: '12px' }}>
                                ИНН {item.vacancy?.employer?.inn}
                              </p>
                            </td>
                          </>
                        ) : (
                          <>
                            {' '}
                            <td className={clsx('pz-2 py-3 whitespace-nowrap text-sm text-gray-800 pr-2', item?.unread_messages && item?.type !== 'employer_candidate' && 'font-bold')}>
                              <p>
                                {secondSide?.user?.id ?? secondSide?.employer?.id} - {secondSide?.user?.full_name ?? secondSide?.employer?.name}
                              </p>{' '}
                              {secondSide?.employer && (
                                <p className="text-gray-400" style={{ fontSize: '12px' }}>
                                  ИНН {secondSide?.employer?.inn}
                                </p>
                              )}
                            </td>
                          </>
                        )}
                        {((item?.type !== 'employer_candidate' && item?.type !== 'staff_candidate') || isSelf) && (
                          <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-400  " style={{ paddingLeft: '20px' }}>
                            <div className="relative max-w-[240px] ">
                              <div className=" items-center gap-2">
                                <div className={item?.unread_messages ? 'font-bold text-black' : ''}>
                                  {' '}
                                  {item.last_message?.content_type == 'text' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="absolute " style={{ left: '-21px', top: '0px' }}>
                                      <g fill="none" stroke={item?.unread_messages ? '#000' : 'rgb(156, 163, 175)'} stroke-width={item?.unread_messages ? '2' : '1.5'}>
                                        <rect width="16" height="12" x="4" y="6" rx="2" />
                                        <path d="m4 9l7.106 3.553a2 2 0 0 0 1.788 0L20 9" />
                                      </g>
                                    </svg>
                                  ) : item?.last_message?.content_type == 'candidate' ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" className="absolute " style={{ left: '-21px', top: '0px' }}>
                                      <path
                                        fill="rgb(156, 163, 175)"
                                        d="M7.5 5C9.43 5 11 6.57 11 8.5S9.43 12 7.5 12S4 10.43 4 8.5S5.57 5 7.5 5M1 19v-2.5C1 14.57 4.46 13 7.5 13c1.18 0 2.42.24 3.5.64v1.92c-.82-.34-2.09-.56-3.5-.56C5 15 3 15.67 3 16.5v.5h8v2zm21 0h-8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h5l4 4v9c0 .55-.45 1-1 1M15 7v10h6v-7h-3V7zM7.5 7C6.67 7 6 7.67 6 8.5S6.67 10 7.5 10S9 9.33 9 8.5S8.33 7 7.5 7"
                                      />
                                    </svg>
                                  ) : (
                                    <></>
                                  )}
                                  <p className="truncate"> {item.last_message?.content_type == 'text' ? item.last_message?.text : item?.last_message?.content_type == 'candidate' ? `Анкета соискателя` : ''}</p>
                                </div>
                                {/* {item?.unread_messages ? <span class="bg-purple-100 text-red-500 text-xs font-medium px-2.5 py-0.5 rounded-lg">{item?.unread_messages}</span> : <div></div>} */}
                              </div>
                            </div>
                          </td>
                        )}

                        {item?.type == 'support' ? (
                          <VacancyCellManager isSupport chatId={item?.id} manager={item?.manager} />
                        ) : item?.vacancy ? (
                          <VacancyCellManager num={item.vacancy?.id} manager={item.vacancy?.manager} />
                        ) : (
                          <>
                            {!isSelf && (
                              <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-800">
                                {' '}
                                {firstSide?.user?.id ?? firstSide?.employer?.id} - {firstSide?.user?.full_name ?? firstSide?.employer?.name}
                              </td>
                            )}

                            {(item?.type == 'employer_candidate' || item?.type == 'staff_candidate') && <VacancyCellManager isSupport chatId={item?.id} manager={item?.manager} />}
                          </>
                        )}
                        <td className="pl-2 py-3 whitespace-nowrap text-sm text-gray-800">{dayjs(item.last_message?.created_at).format('HH:mm DD.MM.YY')}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MessagesList;
